export default {
  title: 'Oversigt',
  table_title: 'Reservationer',
  filters: {
    card_title: 'Filtre',
    today: 'I dag',
    upcoming: 'Kommende',
    past: 'Tidligere',
    all: 'Alle',
    all_dates: 'Hele perioden',
    pending: 'Afventer bekræftelse',
    canceled: 'Annulleret',
    removed: 'Fjernet',
    date_label: 'Dato:',
    status_label: 'Status:',
    source_label: 'Kilde:',
    source_website: 'Hjemmeside',
    source_google: 'Google',
    search_label: 'Søg:',
    search_placeholder: 'Søg efter fornavn eller efternavn',
    custom_date_tooltip: 'Vælg en bestemt dato',
    active_label: 'Aktive filtre:',
    clear_all: 'Ryd alle',
  },
  tooltips: {
    total_reservations: 'Reservationer i alt',
    total_guests: 'Gæster i alt',
    refresh: 'Opdater',
  },
  empty: {
    default: 'Ingen reservationer endnu.',
    filtered: 'Ingen reservationer matcher dine filtre.',
  },
  fields: {
    company: 'Restaurant',
    datetime: 'Dato / tid',
    customer: 'Kunde',
    source: 'Kilde',
    guests: 'Gæster',
    status: 'Status',
    created_at: 'Oprettet',
  },
  status: {
    confirmed: 'Bekræftet',
    pending: 'Afventer godkendelse',
    canceled: 'Annulleret',
    rejected: 'Afvist',
    removed: 'Fjernet',
  },
  buttons: {
    details: 'Detaljer',
    add_reservation: 'Tilføj reservation',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
